import React from 'react';
import styled from 'styled-components/macro';
import { Layout, Error } from 'components/organisms';
import {
  Text,
} from 'components/atoms';
import { useRouterContext } from 'hooks';
import { Link } from 'react-router-dom';

const NotFound = () => {
  const {
    location: { pathname },
  } = useRouterContext();

  return (
    <Layout modifiers={['stretch']}>
      <Page>
        <Fullscreen>
          <Error
            message="Página não encontrada"
            code={404}
            helper={(
              <Text>
              A página
                {' '}
                {pathname}
                {' '}
não existe.
                {' '}
                <Link to="/">Voltar à página inicial</Link>
              </Text>
            )}
          />
        </Fullscreen>
      </Page>
    </Layout>
  );
};

const Fullscreen = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Page = styled.div`
`;

export default NotFound;
